import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';

Vue.use(Router);

const LOYALTY_PATH_PREFIXES = ['/reward-point', '/loyalty-point'];

export function isLoyaltyRoute(route) {
  return LOYALTY_PATH_PREFIXES.some(prefix => route.path.startsWith(prefix));
}

export function loyaltyScrollBehavior(to, _from, savedPosition) {
  if (!isLoyaltyRoute(to)) return;

  if (savedPosition) return savedPosition;

  return { x: 0, y: 0 };
}

// https://github.com/nuxt-community/router-module#accessing-default-router
export function createRouter() {
  return new Router({
    mode: 'history',
    routes,
    scrollBehavior: loyaltyScrollBehavior,
  });
}

export default { createRouter };
